
import React, { useState } from 'react';

import Content, { ContentTypes } from '../../controllers/Content';

import './MainPlayerOverlays.css';

const MultichannelOverlays = props => {
  const { multiChannel, backgroundColor, specificContentHandler } = props;
  const { mainIconUrl, contents, iconUrls } = multiChannel;

  const [ displayMultichannel, setDisplayMultichannel ] = useState( false);

  return (
    <div className='change-channel' style={{ backgroundColor }}>
      { displayMultichannel ? <div className='change-channel-menu' style={{ backgroundColor }}>
        { contents.map( (content,i) => <img
          className='change-channel-button'
          src={ iconUrls[i] }
          alt={ `channel - ${i}` }
          onClick={ _ => Content.changeMultiChannel( multiChannel, i, specificContentHandler ) }
        />) }
      </div> : <div /> }
      <img
        src={ mainIconUrl }
        alt='change channel'
        className='change-channel-button'
        onClick={ _ => setDisplayMultichannel( !displayMultichannel ) }
      />
    </div>
  );
};

export default function MainPlayerOverlays( props) {
  // console.log( 'components::MainPlayerOverlays::MainPlayerOverlays - props: ', props);    // DEVELOP
  const { contentData, PlayerComponent } = props;
  const { specificContentHandler } = PlayerComponent;
  const backgroundColor = props.auxiliarData?.menusBackground;

  return (
    <div className='MainPlayerOverlays'>
      { contentData.contentType === ContentTypes.MultiChannel ? <MultichannelOverlays
        multiChannel={ contentData.multiChannel }
        backgroundColor={ backgroundColor }
        specificContentHandler={ specificContentHandler }
      /> : <div /> }
    </div>
  );
}
